<div id="gross-revenue-container" class="container-fluid">
    <!-- <div id="gross-revenue-header">
        <h5 class="page-header">Gross Revenue</h5>
    </div> -->
    <div id="gross-revenue-card-container" class="row justify-content-around">
        <!-- Gross Revenue YTD Card -->
        <div id="gross-revenue-ytd-card" class="col-12">
            <!-- NOTE: Change the class property to "col-sm-12 col-md-10 col-lg-6 col-xxl-6" for responsiveness -->
            <mat-card appearance="raised" class="pias-card">
                <mat-card-header class="pias-card-header">
                    <mat-card-title class="pias-card-title">2025 Total Gross Revenue (Year to Date)</mat-card-title>
                </mat-card-header>
                <mat-card-content class="pias-card-content">
                    <div class="pias-card-content-container row">
                        <div
                            class="pias-card-content-set pias-card-border-left col-sm-12 col-md-12 col-lg-6 col-xxl-6 mt-1">
                            <div class="row gr-content gr-content-life-insurance">
                                <div class="col-5 d-flex justify-content-end align-items-center">
                                    <mat-icon class="text-center gr-icons">favorite</mat-icon>
                                </div>
                                <div class="col-7 d-flex flex-column justify-content-start">
                                    <div class="pias-card-content-header text-center gr-content-title">
                                        Life Insurance
                                    </div>
                                    <div class="pias-card-content-body text-center gr-content-body">
                                        {{this.grossRevenueSummary.grLifeInsurance |
                                        currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="row gr-content gr-content-investment">
                                <div class="col-5 d-flex justify-content-end align-items-center">
                                    <mat-icon class="text-center gr-icons">show_chart</mat-icon>
                                </div>
                                <div class="col-7 d-flex flex-column justify-content-start">
                                    <div class="pias-card-content-header text-center gr-content-title">
                                        Investment
                                    </div>
                                    <div class="pias-card-content-body text-center gr-content-body">
                                        {{this.grossRevenueSummary.grInvestments|
                                        currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="pias-card-content-set col-sm-12 col-md-12 col-lg-6 col-xxl-6 mt-1">
                            <div class="row gr-content gr-content-general-insurance">
                                <div class="col-5 d-flex justify-content-end align-items-center">
                                    <mat-icon class="text-center gr-icons">security</mat-icon>
                                </div>
                                <div class="col-7 d-flex flex-column justify-content-start">
                                    <div class="pias-card-content-header text-center gr-content-title">
                                        General Insurance
                                    </div>
                                    <div class="pias-card-content-body text-center gr-content-body">
                                        {{this.grossRevenueSummary.grGeneralInsurance |
                                        currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="row gr-content gr-content-fee-referral">
                                <div class="col-5 d-flex justify-content-end align-items-center">
                                    <mat-icon class="text-center gr-icons">handshake</mat-icon>
                                </div>
                                <div class="col-7 d-flex flex-column justify-content-start">
                                    <div class="pias-card-content-header text-center gr-content-title">
                                        Fees & Referrals
                                    </div>
                                    <div class="pias-card-content-body text-center gr-content-body">
                                        {{this.grossRevenueSummary.grFeeAndReferral |
                                        currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider class="pias-card-divider"></mat-divider>
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header total-gross-revenue-text">Total Gross Revenue</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-body total-gross-revenue-text">
                                {{this.grossRevenueSummary.grTotal |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

    </div>

    <div id="gross-revenue-by-manager-table-container" [hidden]="isGrossRevenueByManagerTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <!-- Gross Revenue By Manager Table -->
        <mat-accordion class="pias-accordian">
            <mat-expansion-panel class="pias-expansion-panel" [expanded]="true">
                <mat-expansion-panel-header class="pias-expansion-panel-header">
                    <mat-panel-title class="pias-expansion-panel-title">
                        <h5 class="header">Gross Revenue Year to Date (By Manager)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="grossRevenueByManagerTableFilterFc"
                        (keyup)="__applyGrossRevenueByManagerDataFilter()" placeholder="Search Gross managers..."
                        #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="grossRevenueByManagerTableFilterFc.value" type="button"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearManagerSearch()" aria-label="Clear search">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Gross Revenue (By manager) List Table -->
                <div id="gross-revenue-by-manager-table" class="pias-table-container">
                    <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
                        [dataSource]="grossRevenueByManagerTableDataSource" matSort matSortDisableClear
                        matSortActive="totalGrossRevenueYtd" matSortDirection="desc"
                        #grossRevenueByManagerTableSort="matSort">

                        <!-- Rep. Code Column -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 100px;">
                                {{grData.repCode}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 150px;">
                                <a class="branch-popup-link"
                                    (click)="this.__displayManagerWiseAdvisors(grData.repCode, grData.personName)">{{grData.personName}}</a>
                            </td>
                        </ng-container>

                        <!-- Branch Column -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 200px;">
                                {{grData.branch}} </td>
                        </ng-container>

                        <!-- Life Insurance Ytd Column -->
                        <ng-container matColumnDef="lifeInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Life <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.lifeInsuranceYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Investment Ytd Column -->
                        <ng-container matColumnDef="investmentYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Investment </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.investmentYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- General Insurance Ytd Column -->
                        <ng-container matColumnDef="generalInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> General <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.generalInsuranceYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Fee And Referrals Ytd Column -->
                        <ng-container matColumnDef="feeAndReferralYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Fees <br> & Referrals </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.feeAndReferralYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Total Gross Revenue Ytd Column -->
                        <ng-container matColumnDef="totalGrossRevenueYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Total <br> Gross Revenue </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.totalGrossRevenueYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="grossRevenueByAdvisorTableDisplayColumn; sticky: true">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: grossRevenueByAdvisorTableDisplayColumn;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Gross Revenue (By manager) Table Paginator -->
                    <mat-paginator #grossRevenueByManagerTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of gross revenue by manager data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div id="gross-revenue-by-advisor-table-container" [hidden]="isGrossRevenueByAdvisorTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <!-- Gross Revenue By Adisor Table -->
        <mat-accordion class="pias-accordian">
            <mat-expansion-panel class="pias-expansion-panel" [expanded]="true">
                <mat-expansion-panel-header class="pias-expansion-panel-header">
                    <mat-panel-title class="pias-expansion-panel-title">
                        <h5 class="header">Gross Revenue Year to Date (By advisor)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Gross Revenue (By advisor) Data Filtering -->
                <!-- <mat-form-field class="w-100">
                    <mat-label>Search Gross Advisor (By advisor)</mat-label>
                    <input type="text" matInput [formControl]="grossRevenueByAdvisorTableFilterFc"
                        (keyup)="__applyGrossRevenueByAdvisorDataFilter()" placeholder="Ex. Rep. code, name" />
                </mat-form-field> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="grossRevenueByAdvisorTableFilterFc"
                        (keyup)="__applyGrossRevenueByAdvisorDataFilter()" placeholder="Search Gross advisors..."
                        #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="grossRevenueByAdvisorTableFilterFc.value" type="button"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearSearch()" aria-label="Clear search">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Gross Revenue (By advisor) List Table -->
                <div id="gross-revenue-by-advisor-table" class="pias-table-container">
                    <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
                        [dataSource]="grossRevenueByAdvisorTableDataSource" matSort matSortDisableClear
                        matSortActive="totalGrossRevenueYtd" matSortDirection="desc"
                        #grossRevenueByAdvisorTableSort="matSort">

                        <!-- Rep. Code Column -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 100px;">
                                {{grData.repCode}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 150px;">
                                {{grData.personName}} </td>
                        </ng-container>

                        <!-- Branch Column -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 200px;">
                                {{grData.branch}} </td>
                        </ng-container>

                        <!-- Life Insurance Ytd Column -->
                        <ng-container matColumnDef="lifeInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Life <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.lifeInsuranceYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Investment Ytd Column -->
                        <ng-container matColumnDef="investmentYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Investment </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.investmentYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- General Insurance Ytd Column -->
                        <ng-container matColumnDef="generalInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> General <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.generalInsuranceYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Fee And Referrals Ytd Column -->
                        <ng-container matColumnDef="feeAndReferralYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Fees <br> & Referrals </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.feeAndReferralYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Total Gross Revenue Ytd Column -->
                        <ng-container matColumnDef="totalGrossRevenueYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Total <br> Gross Revenue </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.totalGrossRevenueYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="grossRevenueByAdvisorTableDisplayColumn; sticky: true">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: grossRevenueByAdvisorTableDisplayColumn;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Gross Revenue (By advisor) Table Paginator -->
                    <mat-paginator #grossRevenueByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of gross revenue by advisor data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div id="gross-revenue-by-branch-table-container" [hidden]="isGrossRevenueByBranchTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <!-- Gross Revenue By Branch Table -->
        <mat-accordion class="pias-accordian">
            <mat-expansion-panel class="pias-expansion-panel" [expanded]="true">
                <mat-expansion-panel-header class="pias-expansion-panel-header">
                    <mat-panel-title class="pias-expansion-panel-title">
                        <h5 class="header">Gross Revenue Year to Date (By branch)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Gross Revenue (By branch) Data Filtering -->
                <!-- <mat-form-field class="w-100">
                    <mat-label>Search Gross Branch (By branch)</mat-label>
                    <input type="text" matInput [formControl]="grossRevenueByBranchTableFilterFc"
                        (keyup)="__applyGrossRevenueByBranchDataFilter()" placeholder="Ex. Branch" />
                </mat-form-field> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="grossRevenueByBranchTableFilterFc"
                        (keyup)="__applyGrossRevenueByBranchDataFilter()" placeholder="Search Gross Branch..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="grossRevenueByBranchTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearBranchSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Gross Revenue (By branch) List Table -->
                <div id="gross-revenue-by-branch-table" class="pias-table-container">
                    <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
                        [dataSource]="grossRevenueByBranchTableDataSource" matSort matSortDisableClear
                        matSortActive="totalGrossRevenueYtd" matSortDirection="desc"
                        #grossRevenueByBranchTableSort="matSort">

                        <!-- Branch Name Column -->
                        <ng-container matColumnDef="branchName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let grData">
                                <a class="branch-popup-link" (click)="__displayBranchWiseAdvisors(grData.branchName)"
                                    style="max-width: 200px;">{{grData.branchName}}</a>
                            </td>
                        </ng-container>

                        <!-- Life Insurance Ytd Column -->
                        <ng-container matColumnDef="lifeInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Life <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.lifeInsuranceYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Investment Ytd Column -->
                        <ng-container matColumnDef="investmentYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Investment </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.investmentYtd| currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- General Insurance Ytd Column -->
                        <ng-container matColumnDef="generalInsuranceYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> General <br> Insurance </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.generalInsuranceYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Fee And Referrals Ytd Column -->
                        <ng-container matColumnDef="feeAndReferralYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Fees <br> & Referrals </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.feeAndReferralYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Total Gross Revenue Ytd Column -->
                        <ng-container matColumnDef="totalGrossRevenueYtd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Total <br> Gross Revenue </th>
                            <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.totalGrossRevenueYtd|
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="grossRevenueByBranchTableDisplayColumn; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: grossRevenueByBranchTableDisplayColumn;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="7">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Gross Revenue (By branch) Table Paginator -->
                    <mat-paginator #grossRevenueByBranchTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of gross revenue by branch data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>